import script from "./VoiceAgentSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./VoiceAgentSetup.vue?vue&type=script&setup=true&lang=js"

import "./VoiceAgentSetup.vue?vue&type=style&index=0&id=74cfcf72&lang=css"
import "./VoiceAgentSetup.vue?vue&type=style&index=1&id=74cfcf72&lang=css"

const __exports__ = script;

export default __exports__